// extracted by mini-css-extract-plugin
export var contentBody = "_al-9";
export var headerImage = "_al-2";
export var imageButton = "_al-7";
export var imageButtonIcon = "_al-8";
export var imageHeader = "_al-4";
export var imageHeaderText = "_al-5";
export var imageOverlay = "_al-3";
export var imageTitle = "_al-6";
export var imageWrapper = "_al-1";
export var taskList = "_al-a";
export var widget = "_al-0";